import 'intersection-observer';
import { ImageFormat } from '@bg-shared/enums';
import { isImageFormatSupported } from '@bg-shared/utils/isImageFormatSupported';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

isImageFormatSupported(ImageFormat.AVIF).then((isSupported) => {
    if (document.body) {
        document.body.classList.add(isSupported ? 'avif' : 'no-avif');
    }
});

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
((global) => {
    if (!global.console) {
        global.console = {};
    }
    var con = global.console;
    var prop;
    var method;
    var dummy = () => {
        // Intentionally empty
    };
    var properties = ['memory'];
    var methods = (
        'assert,clear,count,debug,dir,dirxml,error,exception,group,' +
        'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
        'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn,timeLog,trace'
    ).split(',');
    prop = properties.pop();
    while (prop) {
        if (!con[prop]) {
            con[prop] = {};
        }
        prop = properties.pop();
    }
    method = methods.pop();
    while (method) {
        if (!con[method]) {
            con[method] = dummy;
        }
        method = methods.pop();
    }

    // keeping system time in the Date object
    Object.defineProperty(global.Date, 'systemNow', {
        value: Date.now,
    });

    // Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);

// Array.flat polyfill for Chrome 60 compatibility (Chrome 69+)
if (!Array.prototype.flat) {
    Array.prototype.flat = function (depth) {
        const actualDepth = depth === undefined ? 1 : Number(depth);

        function flattenArray(arr, currentDepth) {
            var result = [];
            var i;
            for (i = 0; i < arr.length; i++) {
                if (Array.isArray(arr[i]) && currentDepth > 0) {
                    result = result.concat(flattenArray(arr[i], currentDepth - 1));
                } else {
                    result.push(arr[i]);
                }
            }
            return result;
        }

        return flattenArray(this, actualDepth);
    };
}

// Array.flatMap polyfill for Chrome 60 compatibility (Chrome 69+)
if (!Array.prototype.flatMap) {
    Array.prototype.flatMap = function (callback, thisArg) {
        return this.map(callback, thisArg).flat();
    };
}

// Element.getAttributeNames polyfill for Chrome 60 compatibility (Chrome 61+)
// This is needed for react-tooltip to work in older browsers
if (!Element.prototype.getAttributeNames) {
    Element.prototype.getAttributeNames = function () {
        var attributes = this.attributes;
        var names = [];
        var i;
        for (i = 0; i < attributes.length; i++) {
            names.push(attributes[i].name);
        }
        return names;
    };
}

/* eslint-enable */
